
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { CreateTechniqueFormValues } from './FormSchema';

interface MediaUrlFieldsProps {
  form: UseFormReturn<CreateTechniqueFormValues>;
}

export const MediaUrlFields: React.FC<MediaUrlFieldsProps> = ({ form }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        control={form.control}
        name="imageUrl"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Image URL</FormLabel>
            <FormControl>
              <Input placeholder="Enter image URL" {...field} />
            </FormControl>
            <FormDescription>
              Provide a URL to an image demonstrating the technique
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="videoUrl"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Video URL</FormLabel>
            <FormControl>
              <Input placeholder="Enter video URL (YouTube, etc.)" {...field} />
            </FormControl>
            <FormDescription>
              Provide a URL to a video demonstrating the technique
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
